import {
  Box,
  CircularProgress,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useGetEventsQuery } from '../../services/iracedb';
import { IraceEventList } from '..';
import { Error } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import api from '../../services/apiClient';

// const eventsDummy = [
//   {
//     eventId: 39,
//     sport: 'Run',
//     name: 'PORT99 FUN RUN',
//     startRegistrationDate: '2023-12-16T17:00:00.000Z',
//     endRegistrationDate: '2024-01-25T16:59:59.000Z',
//     banner:
//       'https://aa44-2001-448a-1150-621d-9c5b-ddb9-5af1-216a.ngrok-free.app/assets/banner/port99_5.jpg',
//     participant: 314,
//     sports: [
//       { name: 'Run' },
//       { name: 'Ride' },
//       { name: 'Skating' },
//       { name: 'Swimming' },
//       { name: 'Run' },
//       { name: 'Ride' },
//       { name: 'Skating' },
//       { name: 'Swimming' },
//     ],
//   },
//   {
//     eventId: 39,
//     sport: 'Run',
//     name: 'PORT99 FUN RUN',
//     startRegistrationDate: '2023-12-16T17:00:00.000Z',
//     endRegistrationDate: '2024-01-25T16:59:59.000Z',
//     banner:
//       'https://aa44-2001-448a-1150-621d-9c5b-ddb9-5af1-216a.ngrok-free.app/assets/banner/port99_5.jpg',
//     participant: 314,
//     sports: [
//       { name: 'Run' },
//       { name: 'Ride' },
//       { name: 'Skating' },
//       { name: 'Swimming' },
//       { name: 'Run' },
//       { name: 'Ride' },
//       { name: 'Skating' },
//       { name: 'Swimming' },
//     ],
//   },
//   {
//     eventId: 39,
//     sport: 'Run',
//     name: 'PORT99 FUN RUN',
//     startRegistrationDate: '2023-12-16T17:00:00.000Z',
//     endRegistrationDate: '2024-01-25T16:59:59.000Z',
//     banner:
//       'https://aa44-2001-448a-1150-621d-9c5b-ddb9-5af1-216a.ngrok-free.app/assets/banner/port99_5.jpg',
//     participant: 314,
//     sports: [{ name: 'Run' }],
//   },
//   {
//     eventId: 39,
//     sport: 'Run',
//     name: 'PORT99 FUN RUN',
//     startRegistrationDate: '2023-12-16T17:00:00.000Z',
//     endRegistrationDate: '2024-01-25T16:59:59.000Z',
//     banner:
//       'https://aa44-2001-448a-1150-621d-9c5b-ddb9-5af1-216a.ngrok-free.app/assets/banner/port99_5.jpg',
//     participant: 314,
//     sports: [{ name: 'Run' }],
//   },
//   {
//     eventId: 39,
//     sport: 'Run',
//     name: 'PORT99 FUN RUN',
//     startRegistrationDate: '2023-12-16T17:00:00.000Z',
//     endRegistrationDate: '2024-01-25T16:59:59.000Z',
//     banner:
//       'https://aa44-2001-448a-1150-621d-9c5b-ddb9-5af1-216a.ngrok-free.app/assets/banner/port99_5.jpg',
//     participant: 314,
//     sports: [{ name: 'Run' }],
//   },
// ];

const IraceEvents = () => {
  // console.log('irace events');
  const isMobile = useMediaQuery('(max-width: 600px)');
  const [isFetching, setIsFetching] = useState(false);
  const [error, setError] = useState('');
  const [data, setData] = useState([]);
  // const { data, isFetching, error } = useGetEventsQuery();

  useEffect(() => {
    const getEventsQuery = async () => {
      setIsFetching(true);
      setError(null);

      try {
        const response = await api.get('/events/web/home');
        setData(response.data);
        // console.log(response.data);
      } catch (err) {
        console.error(err);
        setError(err);
      } finally {
        setIsFetching(false);
      }
    };

    getEventsQuery();
  }, []);

  // console.log('HERE ', process.env.REACT_APP_BASE_API_URL);
  if (error)
    return (
      <Box
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
        marginTop={'2rem'}
        flexDirection={'column'}
      >
        <Error sx={{ fontSize: '64px', color: '#afafaf' }} />
        <Typography sx={{ color: '#afafaf' }} variant="h3">
          {/* {error.error.split(':')[1].toUpperCase()} */}
          {error.message}
        </Typography>
      </Box>
    );

  if (isFetching)
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          mt: { xs: 8, sm: 5 },
        }}
      >
        <CircularProgress size="4rem" />
      </Box>
    );

  // console.log('here', data);

  return (
    <Box
      style={isMobile ? { padding: '2em 1em' } : {}}
      sx={{ mt: { xs: 8, sm: 5, lg: 8 } }}
    >
      <IraceEventList events={data} />
    </Box>
  );
};

export default IraceEvents;
